<div class="fav_wrap">
    <mat-dialog-content>
        <div class="header">
            <div class="rate-txt">Remove Favourites</div>
            <div>
                <img role="button" class="close" (click)="onClose($event)" src="/assets/icons/Close.svg" alt="close"/>
            </div>
        </div>
        <div class="body">
            <p>Are you sure you want to remove <strong>{{title}}</strong> from your favourites list?</p>
        </div>
        <div class="btn-div">
            <app-button class="button" [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" (onClick)="onClose($event)"></app-button>
            <app-button class="button" [type]="'primary'" [buttonType]="'button'" [buttonText]="'Remove'" (onClick)="onSubmit($event)"></app-button>
        </div>
    </mat-dialog-content>
</div>